export default "__VITE_ASSET__DywgUjPL__"